/* KozyNightmarez - customization add-ons, pricing and print legibility guards */
(function(){
  if (location.pathname.indexOf('/products/') < 0) return;

  var V = { c2:49076414513369, c3:49076414546137, lt:49076414578905, li:49076414611673, bt:49076414644441, bi:49076414677209, tt:49076414709977 };
  var P = { c2:4.99, c3:9.99, lt:2.99, li:4.99, bt:2.99, bi:4.99, tt:3.99 };
  var LABEL = { c2:'2 colour print', c3:'3 colour print', lt:'Inside lid text', li:'Inside lid image', bt:'Bottom text', bi:'Bottom image', tt:'Two tone build' };
  var CASES = [['mini-magnet',70,12],['six-vial',55,18],['peptide-storage',55,20],['30ml-bottle',50,22],['full-kit',45,26],['the-vault',45,26]];
  var HAIR = ['Fancy Script','Horror Drip','Old English','Handwritten Script','Spooky'];

  var info = null;
  for (var i = 0; i < CASES.length; i++) {
    if (location.pathname.indexOf(CASES[i][0]) > -1) { info = { min: CASES[i][1], max: CASES[i][2] }; break; }
  }

  var built = false, els = {}, pushing = false;

  function money(n){ return '$' + n.toFixed(2); }
  function byId(id){ return document.getElementById(id); }
  function val(id){ var e = byId(id); return e ? e.value : null; }
  function shown(e){ return !!(e && e.offsetParent !== null); }

  function mkRow(id, text, opts){
    var row = document.createElement('div');
    row.className = 'knrow';
    row.id = id;
    var lab = document.createElement('label');
    lab.textContent = text;
    var sel = document.createElement('select');
    sel.id = id + '-sel';
    for (var i = 0; i < opts.length; i++) {
      var o = document.createElement('option');
      o.value = opts[i][0];
      o.textContent = opts[i][1];
      sel.appendChild(o);
    }
    row.appendChild(lab);
    row.appendChild(sel);
    return row;
  }

  function hiddenField(form, name, id){
    var h = byId(id);
    if (!h) { h = document.createElement('input'); h.type = 'hidden'; h.id = id; form.appendChild(h); }
    h.name = name;
    return h;
  }

  function build(){
    if (built) return;
    var wrap = byId('knwrap');
    if (!wrap) return;
    var anchor = byId('knrow-textfont') || byId('knrow-textcolor') || byId('knrow-art') || byId('knrow-text');
    if (!anchor) return;

    els.colors = mkRow('knrow-colors','How many print colours? (the case colour counts as one)',[['1','1 colour - included'],['2','2 colours - add ' + money(P.c2)],['3','3 colours - add ' + money(P.c3) + ' (3 is the max)']]);
    els.lid = mkRow('knrow-inlid','Add lettering or art inside the lid',[['none','No thanks'],['text','Text - add ' + money(P.lt)],['image','Image or logo - add ' + money(P.li)]]);
    els.bot = mkRow('knrow-inbot','Add lettering or art on the bottom of the case',[['none','No thanks'],['text','Text - add ' + money(P.bt)],['image','Image or logo - add ' + money(P.bi)]]);
    els.two = mkRow('knrow-twotone','Insert a different colour from the outside',[['no','No - single colour build (included)'],['yes','Yes - two tone build, add ' + money(P.tt)]]);

    anchor.insertAdjacentElement('afterend', els.two);
    anchor.insertAdjacentElement('afterend', els.bot);
    anchor.insertAdjacentElement('afterend', els.lid);
    anchor.insertAdjacentElement('afterend', els.colors);

    els.lidFile = document.createElement('input');
    els.lidFile.type = 'file';
    els.lidFile.accept = 'image/*';
    els.lidFile.id = 'knlidimg';
    els.lidFile.name = 'properties[Inside lid image]';
    els.lid.appendChild(els.lidFile);

    els.botFile = document.createElement('input');
    els.botFile.type = 'file';
    els.botFile.accept = 'image/*';
    els.botFile.id = 'knbotimg';
    els.botFile.name = 'properties[Bottom image]';
    els.bot.appendChild(els.botFile);

    els.total = document.createElement('div');
    els.total.className = 'knrow knnote';
    els.total.id = 'kntotal';
    els.two.insertAdjacentElement('afterend', els.total);

    els.warn = document.createElement('div');
    els.warn.className = 'knrow knwarn';
    els.warn.id = 'knwarn';
    els.total.insertAdjacentElement('afterend', els.warn);

    var css = document.createElement('style');
    css.textContent = '#knwrap .knnote{font-size:13px;opacity:.85;line-height:1.4}#knwrap .knwarn{font-size:13px;line-height:1.4;color:#ffd36e;display:none}#knwrap #knlidimg,#knwrap #knbotimg{display:none;margin-top:6px}';
    document.head.appendChild(css);

    var size = byId('knsize');
    if (info && size && size.parentElement && !byId('knminnote')) {
      size.min = info.min;
      var note = document.createElement('div');
      note.className = 'knnote';
      note.id = 'knminnote';
      note.textContent = 'On this case the size slider stops at ' + info.min + '%. Below that the lettering and art get too fine to print or read cleanly.';
      size.parentElement.appendChild(note);
    }

    var form = document.querySelector('form[action*="/cart/add"]');
    if (form) {
      els.hColors = hiddenField(form,'properties[Print colours]','knh-colors');
      els.hLid = hiddenField(form,'properties[Inside lid decoration]','knh-lid');
      els.hBot = hiddenField(form,'properties[Bottom decoration]','knh-bot');
      els.hTwo = hiddenField(form,'properties[Two tone build]','knh-two');
      els.hAdd = hiddenField(form,'properties[Add-on total]','knh-add');
    }

    built = true;
  }

  function decorationOn(){
    return shown(byId('knrow-text')) || shown(byId('knrow-art'));
  }

  function addonList(){
    if (!built || !decorationOn()) return [];
    var out = [];
    var c = val('knrow-colors-sel');
    if (c === '2') out.push('c2');
    if (c === '3') out.push('c3');
    var l = val('knrow-inlid-sel');
    if (l === 'text') out.push('lt');
    if (l === 'image') out.push('li');
    var b = val('knrow-inbot-sel');
    if (b === 'text') out.push('bt');
    if (b === 'image') out.push('bi');
    if (val('knrow-twotone-sel') === 'yes') out.push('tt');
    return out;
  }

  function warnings(){
    var msgs = [];
    var size = byId('knsize');
    if (info && size) {
      if (Number(size.min) < info.min) size.min = info.min;
      if (Number(size.value) < info.min) {
        size.value = info.min;
        size.dispatchEvent(new Event('input', { bubbles: true }));
        size.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    var txt = byId('kntxt');
    var len = txt ? txt.value.trim().length : 0;
    if (info && len > info.max) {
      msgs.push('Heads up: ' + len + ' characters is a lot for this case. Past about ' + info.max + ' the letters have to shrink and can get hard to read or hard to print. Shorter text comes out cleaner.');
    }
    var font = val('knrow-textfont-sel');
    if (info && info.max <= 20 && font && HAIR.indexOf(font) > -1) {
      msgs.push('Heads up: ' + font + ' has very thin strokes. On a case this size those hairlines can fill in or flake off. A bolder font holds up better here.');
    }
    var l = val('knrow-inlid-sel'), b = val('knrow-inbot-sel');
    if (info && info.max <= 18 && (l === 'image' || b === 'image' || shown(byId('knrow-art')))) {
      msgs.push('Heads up: fine detail in a logo can get lost at this size. Simple, high contrast art prints best on the smaller cases.');
    }
    return msgs;
  }

  function sync(){
    if (!built) return;
    var on = decorationOn();
    var rows = ['knrow-colors','knrow-inlid','knrow-inbot','knrow-twotone','kntotal'];
    for (var i = 0; i < rows.length; i++) {
      var r = byId(rows[i]);
      if (r) r.style.display = on ? '' : 'none';
    }
    var sels = ['knrow-colors-sel','knrow-inlid-sel','knrow-inbot-sel','knrow-twotone-sel'];
    for (var j = 0; j < sels.length; j++) {
      var s = byId(sels[j]);
      if (s) s.disabled = !on;
    }

    var l = val('knrow-inlid-sel'), b = val('knrow-inbot-sel');
    if (els.lidFile) { els.lidFile.style.display = (on && l === 'image') ? 'block' : 'none'; els.lidFile.disabled = !(on && l === 'image'); }
    if (els.botFile) { els.botFile.style.display = (on && b === 'image') ? 'block' : 'none'; els.botFile.disabled = !(on && b === 'image'); }

    var lidTxt = byId('knlid'), botTxt = byId('knbot');
    if (lidTxt && lidTxt.parentElement) lidTxt.parentElement.style.display = (on && l !== 'none') ? '' : 'none';
    if (botTxt && botTxt.parentElement) botTxt.parentElement.style.display = (on && b !== 'none') ? '' : 'none';

    var list = addonList(), tot = 0, names = [];
    for (var k = 0; k < list.length; k++) { tot += P[list[k]]; names.push(LABEL[list[k]]); }
    if (els.total) {
      if (!on) els.total.textContent = '';
      else if (tot > 0) els.total.textContent = 'Extras: +' + money(tot) + ' (' + names.join(', ') + '). These are added to your cart automatically when you add this case.';
      else els.total.textContent = 'No extras selected. Your lettering or art in a single colour is already included in the price above.';
    }

    if (els.hColors) {
      els.hColors.value = on ? (val('knrow-colors-sel') + ' colour print') : '';
      els.hLid.value = on ? l : '';
      els.hBot.value = on ? b : '';
      els.hTwo.value = on ? val('knrow-twotone-sel') : '';
      els.hAdd.value = (on && tot > 0) ? money(tot) : '';
      var hs = [els.hColors, els.hLid, els.hBot, els.hTwo, els.hAdd];
      for (var m = 0; m < hs.length; m++) hs[m].disabled = !on;
    }

    var msgs = warnings();
    if (els.warn) {
      els.warn.textContent = msgs.join(' ');
      els.warn.style.display = (on && msgs.length) ? 'block' : 'none';
    }
  }

  function quantity(){
    var q = document.querySelector('form[action*="/cart/add"] input[name="quantity"]');
    var n = q ? parseInt(q.value, 10) : 1;
    return (n && n > 0) ? n : 1;
  }

  function pushAddons(){
    var list = addonList();
    if (!list.length) return Promise.resolve();
    var title = (document.title || 'case').split(' - ')[0];
    var items = list.map(function(key){
      var props = {};
      props['Add-on for'] = title;
      props['What'] = LABEL[key];
      return { id: V[key], quantity: quantity(), properties: props };
    });
    return window.__knFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).catch(function(){});
  }

  window.__knFetch = window.fetch.bind(window);
  window.fetch = function(input, init){
    var self = this, args = arguments;
    var url = (typeof input === 'string') ? input : ((input && input.url) || '');
    var method = (init && init.method) || (input && input.method) || 'GET';
    if (!pushing && String(method).toUpperCase() === 'POST' && url.indexOf('/cart/add') > -1) {
      pushing = true;
      return pushAddons().then(function(){
        pushing = false;
        return window.__knFetch.apply(self, args);
      }, function(){
        pushing = false;
        return window.__knFetch.apply(self, args);
      });
    }
    return window.__knFetch.apply(this, arguments);
  };

  function tick(){ build(); sync(); }

  document.addEventListener('change', function(e){
    if (e.target && typeof e.target.id === 'string' && e.target.id.indexOf('kn') === 0) sync();
  }, true);
  document.addEventListener('input', function(e){
    if (e.target && (e.target.id === 'kntxt' || e.target.id === 'knsize')) sync();
  }, true);
  document.addEventListener('DOMContentLoaded', tick);
  setInterval(tick, 700);
  tick();
})();
(function(){
if(location.pathname.indexOf('hype-chain')<0)return;
function byId(i){return document.getElementById(i);}
var built=false, els={};
function mkRow(id,label,help,child){
  var d=document.createElement('div');
  d.className='knrow';d.id=id;
  var l=document.createElement('label');
  l.className='knlab';l.textContent=label;
  d.appendChild(l);d.appendChild(child);
  if(help){var h=document.createElement('div');h.className='knnote';h.textContent=help;d.appendChild(h);}
  return d;
}
function mkSel(id,opts){
  var s=document.createElement('select');
  s.id=id;s.className='knsel';
  for(var i=0;i<opts.length;i++){
    var o=document.createElement('option');
    o.value=opts[i][0];o.textContent=opts[i][1];
    s.appendChild(o);
  }
  return s;
}
function hid(form,name,id){
  var h=byId(id);
  if(h)return h;
  h=document.createElement('input');
  h.type='hidden';h.name=name;h.id=id;
  form.appendChild(h);
  return h;
}
function build(){
  if(built)return;
  var form=document.querySelector('form[action*="/cart/add"]');
  if(!form)return;
  var anchor=form.querySelector('.product-form-buttons');
  if(!anchor)return;
  var css=document.createElement('style');
  css.textContent='#knchain-highlight{background:#fff;border-radius:14px;padding:18px;margin:14px 0;box-shadow:0 0 0 2px rgba(0,0,0,.08)}.knrow{margin:14px 0}.knlab{display:block;font-weight:700;margin-bottom:5px;color:#111}#knchain-highlight input,#knchain-highlight select,#knchain-highlight .knsel,#knchain-highlight .kninp{width:100%;padding:9px;border:1px solid #bbb;border-radius:6px;background:#fff !important;color:#111 !important;-webkit-text-fill-color:#111}#knchain-highlight input::placeholder{color:#666 !important;opacity:1 !important}.knnote{font-size:12px;opacity:.75;margin:5px 0;color:#333}';
  document.head.appendChild(css);
  var w=document.createElement('div');
  w.id='knchain';var sizeNote=document.createElement('div');sizeNote.className='knnote';sizeNote.textContent='Pendant is approx. 6" x 6". Chain length is approx. 30"-36".';w.appendChild(sizeNote);
  var ct=document.createElement('input');ct.type='text';ct.id='knchaincolors';ct.className='kninp';ct.maxLength=60;ct.placeholder='Example: Purple (or Purple and Silver for 2-3 colors)';w.appendChild(mkRow('knrow-colors','What color(s) do you want for your chain?','Please tell us your color choice: 1 color for Single Color, or the exact colors for a 2 or 3-Color Chain.',ct));
  var t=document.createElement('input');
  t.type='text';t.id='kntext';t.className='kninp';t.maxLength=40;t.placeholder='Example: Cowboys';t.required=true;
  w.appendChild(mkRow('knrow-team','What team do you want?','Tell us the team or logo you\u2019d like on your hype chain.',t));var f=document.createElement('input');f.type='file';f.id='knlogo';f.name='properties[Logo Upload]';f.accept='image/*';f.className='kninp';w.appendChild(mkRow('knrow-logo','Upload a logo (optional)','Got a specific logo or design? Upload an image and we will use it instead of text.',f));form.enctype='multipart/form-data';
  var wrap=document.createElement('div');wrap.id='knchain-highlight';anchor.parentNode.insertBefore(wrap,anchor);wrap.appendChild(w);wrap.appendChild(anchor);
  els.a=hid(form,'properties[Chain Type]','knh-a');
  els.b=hid(form,'properties[Team]','knh-b');els.c=hid(form,'properties[Link Colors]','knh-c');
  built=true;
}
function sync(){
  if(!built)return;
  var styleMap={chain:'Chain',cuban:'Cuban link'};
  var csEl=document.querySelector('input[name^="Chain Style-"]:checked');els.a.value=csEl?csEl.value:'Chain';
  els.b.value=byId('kntext').value||'';els.c.value=byId('knchaincolors').value||'';
}
function tick(){build();sync();}
document.addEventListener('change',function(e){if(e.target&&typeof e.target.id==='string'&&e.target.id.indexOf('kn')===0)sync();},true);
document.addEventListener('input',function(e){if(e.target&&e.target.id==='kntext')sync();},true);
document.addEventListener('DOMContentLoaded',tick);
setInterval(tick,800);
tick();
})();
/* sitewide product disclaimer */
(function(){
if(location.pathname.indexOf('/products/')<0)return;
function run(){
if(document.getElementById('kndisc'))return;
var host=document.querySelector('main')||document.body;
var d=document.createElement('div');
d.id='kndisc';
d.style.cssText='margin:26px auto;max-width:900px;padding:14px 16px;border:1px solid #7c3aed;border-radius:8px;background:#140a20;color:#e9e2f5;font-size:12px;line-height:1.55';
var pt='';try{pt=(window.ShopifyAnalytics&&ShopifyAnalytics.meta&&ShopifyAnalytics.meta.product&&ShopifyAnalytics.meta.product.type)||'';}catch(e){}
var AP=/(t-shirt|tshirt|-tee|tee-|hoodie|sweatshirt|crewneck|tank|apparel|shirt)/i.test(location.pathname+' '+pt);
var t='<strong>Product Notice and Disclaimer</strong><br><br>';
if(AP){t+='<b>Our own artwork.</b> Every apparel design sold here is original artwork created in house by KozyNightmarez. We do not copy or resell designs owned by anyone else, and our shirt designs stay our property - they may not be reproduced or resold without our written permission. KozyNightmarez is an independent small shop and is not affiliated with, sponsored by, endorsed by, or licensed by any other company or brand.<br><br>';}
else{t+='<b>Independent business.</b> KozyNightmarez is an independent small shop. We are not affiliated with, sponsored by, endorsed by, or licensed by any sports league, team, movie studio, entertainment company, or brand. Any team, character or brand name mentioned on this site is used only to describe the look a customer asked for.<br><br>';}
if(/(candle|wax|scent)/i.test(location.pathname+' '+pt)){t+='<b>Hand poured and hand scented.</b> Our candles are poured, scented and finished by hand in small batches right here at KozyNightmarez. Scent names are our own creative take on a mood, a feeling or a favorite character, and nothing more. A name is not a licensed product. We are not affiliated with, sponsored by, endorsed by, or licensed by any author, publisher, film studio or franchise, and no book, film or character is being sold. Because every candle is hand poured, color, scent strength, wax finish and top details can vary a little from batch to batch.<br><br>';}
t+='<b>Made by hand, made to order.</b> Nothing here is mass produced. 3D printed pieces are printed one at a time, candles are poured and scented by hand in small batches, and apparel is printed on demand, so color, finish, texture, scent strength, exact size and small details can vary from the photos. Photos may show earlier versions, different color choices, or display props, so your item will not be an exact match to the picture.<br><br>';
t+='<b>Custom designs.</b> If you send us artwork, a logo, a photo or wording, you are confirming that you have the right to use it. You are responsible for making sure your design does not infringe copyrights or trademarks owned by others. We may decline any request.<br><br>';
t+='<b>Timing and returns.</b> Production time is needed before shipping. Custom and personalized items are not returnable unless they arrive damaged or incorrect. Not a toy - small parts and chains are not intended for children under 3.';
d.innerHTML=t;
var f=document.querySelector('form[action*="/cart/add"]');
if(f&&f.parentNode)f.parentNode.appendChild(d);else host.appendChild(d);
}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',run);else run();
setTimeout(run,1500);
})();
